export default {
  "Sign Up Error": {
    english: "Sign Up Error",
    spanish: "Error de registro"
  },
  "Your Password has been reset": {
    english: "Your Password has been reset",
    spanish: "Tu contraseña ha sido restablecida"
  },
  "Reset Password Error": {
    english: "Reset Password Error",
    spanish: "Error de restablecimiento de contraseña"
  },
  "Your Password has been updated": {
    english: "Your Password has been updated",
    spanish: "Tu contraseña ha sido actualizada"
  },
  "Could not join chat": {
    english: "Could not join chat",
    spanish: "No se pudo unir al chat"
  },
  Success: {
    english: "Success",
    spanish: "Éxito"
  },
  Error: {
    english: "Error",
    spanish: "Error"
  },
  "Order Submitted": {
    english: "Order Submitted",
    spanish: "Orden enviada"
  },
  "Your profile has been updated": {
    english: "Your profile has been updated",
    spanish: "Tu perfil ha sido actualizado"
  },
  "Could not update your profile": {
    english: "Could not update your profile",
    spanish: "No se pudo actualizar tu perfil"
  },
  "Please login": {
    english: "Please login",
    spanish: "Por favor Iniciar sesión"
  },
  "Your Session has expired": {
    english: "Your Session has expired",
    spanish: "Su sesión ha caducado"
  },
  "Patient has been updated.": {
    english: "Patient has been updated.",
    spanish: "El paciente ha sido actualizado."
  },
  "Notification Settings updated successfully": {
    english: "Notification Settings updated successfully",
    spanish: "La configuración de notificaciones se actualizó correctamente"
  },
  "Order Added Successfully": {
    english: "Order Added Successfully",
    spanish: "Pedido agregado con éxito"
  },
  "We saved this Questionnaire Response successfully.": {
    english: "We saved this Questionnaire Response successfully.",
    spanish: "Guardamos esta respuesta al cuestionario con éxito."
  },
  "Password Updated Successfully.": {
    english: "Password Updated Successfully.",
    spanish: "Contraseña actualizada exitosamente."
  },
  "SMS consent saved successfully": {
    english: "SMS consent saved successfully",
    spanish: "Consentimiento para SMS guardado exitosamente"
  },
  "Biometric login enabled successfully": {
    english: "Biometric login enabled successfully",
    spanish: "Login con datos biometricos activado exitosamente"
  },
  "Biometric login disabled successfully": {
    english: "Biometric login disabled successfully",
    spanish: "Login con datos biometricos desactivado exitosamente"
  },
  "Order Created Successfully": {
    english: "Order Created Successfully",
    spanish: "Orden creada exitosamente"
  },
  "Incomplete Order Tracking Created Successfully": {
    english: "Incomplete Order Tracking Created Successfully",
    spanish: "Seguimiento de orden incompleta creado exitosamente"
  },
  "Pushed outreach date": {
    english: "Pushed outreach date",
    spanish: "Fecha de contacto actualizada"
  },
  "Updated the FCM Token": {
    english: "Updated the FCM Token",
    spanish: "Token FCM actualizado"
  },
  "Forms fetched successfully": {
    english: "Forms fetched successfully",
    spanish: "Formularios obtenidos exitosamente"
  },
  "Retrieved Notification Settings successfully.": {
    english: "Retrieved Notification Settings successfully.",
    spanish: "Configuración de notificaciones obtenida exitosamente."
  },
  "Retrieved Questionnaire Assignment details successfully.": {
    english: "Retrieved Questionnaire Assignment details successfully.",
    spanish: "Detalles de asignación de cuestionario obtenidos exitosamente."
  },
  "Retrieved Questionnaire Response successfully.": {
    english: "Retrieved Questionnaire Response successfully.",
    spanish: "Respuesta del cuestionario obtenida exitosamente."
  },
  "Unsupported Media": {
    english: "Unsupported Media",
    spanish: "Tipo de archivo no soportado"
  },
  "Retrieved Documents Successfully.": {
    english: "Retrieved Documents Successfully.",
    spanish: "Documentos obtenidos exitosamente."
  },
  "Video added successfully": {
    english: "Video added successfully",
    spanish: "Video agregado exitosamente"
  },
  "Video set to not active successfully.": {
    english: "Video set to not active successfully.",
    spanish: "Video desactivado exitosamente."
  },
  "Product photo added successfully.": {
    english: "Product photo added successfully.",
    spanish: "Foto del producto agregada exitosamente."
  },
  "Invalid username/password combination": {
    english: "Invalid username/password combination",
    spanish: "Combinación de usuario/contraseña inválida"
  },
  "Sorry we could not find your notification settings.": {
    english: "Sorry we could not find your notification settings.",
    spanish: "Lo sentimos, no pudimos encontrar tu configuración de notificaciones."
  },
  "Sorry, there was no Questionnaire Response found.": {
    english: "Sorry, there was no Questionnaire Response found.",
    spanish: "Lo sentimos, no se encontró ninguna respuesta al cuestionario."
  },
  "Sorry, we could not save your response, this Questionnaire Assignment could not be found.": {
    english: "Sorry, we could not save your response, this Questionnaire Assignment could not be found.",
    spanish: "Lo sentimos, no pudimos guardar tu respuesta, esta asignación de cuestionario no se pudo encontrar."
  },
  "Sorry, we could not save your response.  There were no answers passed in.": {
    english: "Sorry, we could not save your response.  There were no answers passed in.",
    spanish: "Lo sentimos, no pudimos guardar tu respuesta. No se pasaron respuestas."
  },
  "Sorry you have exceeded the amount of attempts allowed, please login to continue with your order": {
    english: "Sorry you have exceeded the amount of attempts allowed, please login to continue with your order",
    spanish: "Lo sentimos, has excedido la cantidad de intentos permitidos, por favor inicia sesión para continuar con tu pedido"
  },
  "Sorry we cannot find patient.": {
    english: "Sorry we cannot find patient.",
    spanish: "Lo sentimos, no podemos encontrar al paciente."
  },
  "Failed To Logout.": {
    english: "Failed To Logout.",
    spanish: "Error al cerrar sesión."
  },
  "Could not authenticate account": {
    english: "Could not authenticate account",
    spanish: "No se pudo autenticar la cuenta"
  },
  "Sorry, MFA via SMS is not available": {
    english: "Sorry, MFA via SMS is not available",
    spanish: "Lo sentimos, la autenticación de dos factores por SMS no está disponible"
  },
  "Sorry, something went wrong and your product photo upload was not successful.": {
    english: "Sorry, something went wrong and your product photo upload was not successful.",
    spanish: "Lo sentimos, algo salió mal y la carga de la foto del producto no fue exitosa."
  },
  "Document not found.": {
    english: "Document not found.",
    spanish: "Documento no encontrado."
  },
  "Sorry, we could not find this Document.": {
    english: "Sorry, we could not find this Document.",
    spanish: "Lo sentimos, no pudimos encontrar este documento."
  },
  "We could not upload this signature.": {
    english: "We could not upload this signature.",
    spanish: "No pudimos cargar esta firma."
  },
  "This document could not be found.": {
    english: "This document could not be found.",
    spanish: "Este documento no se pudo encontrar."
  },
  "We could not upload this signature document.": {
    english: "We could not upload this signature document.",
    spanish: "No pudimos cargar este documento de firma."
  },
  "Sorry, You are not authorized.": {
    english: "Sorry, You are not authorized.",
    spanish: "Lo sentimos, no estás autorizado."
  },
  "Update Language Error": {
    english: "Update Language Error",
    spanish: "Error al actualizar el idioma"
  },
  "Your account was updated": {
    english: "Your account was updated",
    spanish: "Tu cuenta ha sido actualizada"
  },
  "Your Order has been submitted": {
    english: "Your Order has been submitted",
    spanish: "Tu pedido ha sido enviado"
  },
  "Order Error": {
    english: "Order Error",
    spanish: "Error en el pedido"
  },
  "Incomplete Order Tracking Error": {
    english: "Incomplete Order Tracking Error",
    spanish: "Error en el seguimiento de orden incompleta"
  },
  "Appointment answered successfuly": {
    english: "Appointment answered successfuly",
    spanish: "Cita respondida exitosamente"
  },
  "Could not accept or decline the appointment": {
    english: "Could not accept or decline the appointment",
    spanish: "No se pudo aceptar o rechazar la cita"
  },
  "Appointment cancelled successfuly": {
    english: "Appointment cancelled successfuly",
    spanish: "Cita cancelada exitosamente"
  },
  "Could not cancel the appointment": {
    english: "Could not cancel the appointment",
    spanish: "No se pudo cancelar la cita"
  },
  "Appointment Scheduled Successfully.": {
    english: "Appointment Scheduled Successfully.",
    spanish: "Cita programada exitosamente."
  },
  "Logout Was Successful.": {
    english: "Logout Was Successful.",
    spanish: "Cierre de sesión exitoso."
  },
  "Rescheduled Chat Successfully.": {
    english: "Rescheduled Chat Successfully.",
    spanish: "Chat reprogramado exitosamente."
  },
  "Retrieved Coach Availability Time Slots successfully.": {
    english: "Retrieved Coach Availability Time Slots successfully.",
    spanish: "Horarios disponibles del coach obtenidos exitosamente."
  },
  "Appointment Topic Category updated successfully.": {
    english: "Appointment Topic Category updated successfully.",
    spanish: "Categoría de tema de cita actualizada exitosamente."
  },
  "Appointment Topic Category created successfully.": {
    english: "Appointment Topic Category created successfully.",
    spanish: "Categoría de tema de cita creada exitosamente."
  },
  "Retrieved Appointment Topic Categories successfully.": {
    english: "Retrieved Appointment Topic Categories successfully.",
    spanish: "Categorías de temas de citas obtenidas exitosamente."
  },
  "Retrieved Chats successfully.": {
    english: "Retrieved Chats successfully.",
    spanish: "Chats obtenidos exitosamente."
  },
  "Chat history retrieved successfully": {
    english: "Chat history retrieved successfully",
    spanish: "Historial de chat obtenido exitosamente"
  },
  "chat retrieved successfully": {
    english: "chat retrieved successfully",
    spanish: "chat obtenido exitosamente"
  },
  "You have no upcoming appointments.": {
    english: "You have no upcoming appointments.",
    spanish: "No tienes citas próximas."
  },
  "you have had no chats.": {
    english: "you have had no chats.",
    spanish: "no has tenido chats."
  },
  "Chat not found": {
    english: "Chat not found",
    spanish: "Chat no encontrado"
  },
  "We saved this Form Response successfully.": {
    english: "We saved this Form Response successfully.",
    spanish: "Guardamos esta respuesta del formulario exitosamente."
  },
  "Email resent successfully.": {
    english: "Email resent successfully.",
    spanish: "Correo electrónico reenviado exitosamente."
  },
  "Language updated successfully.": {
    english: "Language updated successfully.",
    spanish: "Idioma actualizado exitosamente."
  },
  "Schedule Days updated successfully.": {
    english: "Schedule Days updated successfully.",
    spanish: "Días de horario actualizados exitosamente."
  },
  "Schedule Type Updated Successfully.": {
    english: "Schedule Type Updated Successfully.",
    spanish: "Tipo de horario actualizado exitosamente."
  },
  "Article updated successfully.": {
    english: "Article updated successfully.",
    spanish: "Artículo actualizado exitosamente."
  },
  "We set this Article to not active successfully.": {
    english: "We set this Article to not active successfully.",
    spanish: "Artículo desactivado exitosamente."
  },
  "We could not find any Articles.": {
    english: "We could not find any Articles.",
    spanish: "No pudimos encontrar ningún artículo."
  },
  "Retrieved Articles successfully.": {
    english: "Retrieved Articles successfully.",
    spanish: "Artículos obtenidos exitosamente."
  },
  "Article added successfully": {
    english: "Article added successfully",
    spanish: "Artículo agregado exitosamente"
  },
  "Articles Do Not Exist.": {
    english: "Articles Do Not Exist.",
    spanish: "Los artículos no existen."
  },
  "Here are the call recordings we found with your search.": {
    english: "Here are the call recordings we found with your search.",
    spanish: "Aquí están las grabaciones de llamadas que encontramos con tu búsqueda."
  },
  "Retrieved Insurances successfully.": {
    english: "Retrieved Insurances successfully.",
    spanish: "Seguros obtenidos exitosamente."
  },
  "Sorry, we could not find this Insurance.": {
    english: "Sorry, we could not find this Insurance.",
    spanish: "Lo sentimos, no pudimos encontrar este seguro."
  },
  "We updated the Insurance successfully.": {
    english: "We updated the Insurance successfully.",
    spanish: "Seguro actualizado exitosamente."
  },
  "We set this Service to not active successfully.": {
    english: "We set this Service to not active successfully.",
    spanish: "Servicio desactivado exitosamente."
  },
  "We updated this Service successfully.": {
    english: "We updated this Service successfully.",
    spanish: "Servicio actualizado exitosamente."
  },
  "We added this Service successfully": {
    english: "We added this Service successfully",
    spanish: "Servicio agregado exitosamente"
  },
  "Retrieved Service successfully.": {
    english: "Retrieved Service successfully.",
    spanish: "Servicio obtenido exitosamente."
  },
  "Sorry, we could not find any Services for you.": {
    english: "Sorry, we could not find any Services for you.",
    spanish: "Lo sentimos, no pudimos encontrar ningún servicio para ti."
  },
  "Sorry, there were no questionnaires assigned.": {
    english: "Sorry, there were no questionnaires assigned.",
    spanish: "Lo sentimos, no había cuestionarios asignados."
  },
  "We set this Questionnaire to Not Active successfully.": {
    english: "We set this Questionnaire to Not Active successfully.",
    spanish: "Cuestionario desactivado exitosamente."
  },
  "We updated this Questionnaire successfully": {
    english: "We updated this Questionnaire successfully",
    spanish: "Cuestionario actualizado exitosamente"
  },
  "We added this Questionnaire successfully.": {
    english: "We added this Questionnaire successfully.",
    spanish: "Cuestionario agregado exitosamente."
  },
  "Retrieved Questionnaire successfully.": {
    english: "Retrieved Questionnaire successfully.",
    spanish: "Cuestionario obtenido exitosamente."
  },
  "We could not find any questionnaires.": {
    english: "We could not find any questionnaires.",
    spanish: "No pudimos encontrar ningún cuestionario."
  },
  "You do not have any questionnaire assignments.": {
    english: "You do not have any questionnaire assignments.",
    spanish: "No tienes ninguna asignación de cuestionario."
  },
  "Retrieved Questionnaires successfully.": {
    english: "Retrieved Questionnaires successfully.",
    spanish: "Cuestionarios obtenidos exitosamente."
  },
  "We archived this Questionnaire Assignment successfully.": {
    english: "We archived this Questionnaire Assignment successfully.",
    spanish: "Asignación de cuestionario archivada exitosamente."
  },
  "We set this FAQ to not active successfully.": {
    english: "We set this FAQ to not active successfully.",
    spanish: "Pregunta frecuente desactivada exitosamente."
  },
  "This FAQ was updated successfully": {
    english: "This FAQ was updated successfully",
    spanish: "Pregunta frecuente actualizada exitosamente"
  },
  "This FAQ was saved successfully": {
    english: "This FAQ was saved successfully",
    spanish: "Pregunta frecuente guardada exitosamente"
  },
  "Retrieved FAQ successfully.": {
    english: "Retrieved FAQ successfully.",
    spanish: "Pregunta frecuente obtenida exitosamente."
  },
  "Sorry, currently this product has no FAQs.": {
    english: "Sorry, currently this product has no FAQs.",
    spanish: "Lo sentimos, actualmente este producto no tiene preguntas frecuentes."
  },
  "Retrieved FAQs successfully.": {
    english: "Retrieved FAQs successfully.",
    spanish: "Preguntas frecuentes obtenidas exitosamente."
  },
  "Sorry, it seems that you currently have no FAQs.": {
    english: "Sorry, it seems that you currently have no FAQs.",
    spanish: "Lo sentimos, parece que actualmente no tienes preguntas frecuentes."
  },
  "We set this Document Category to not active successfully.": {
    english: "We set this Document Category to not active successfully.",
    spanish: "Categoría de documento desactivada exitosamente."
  },
  "Document Category was updated successfully.": {
    english: "Document Category was updated successfully.",
    spanish: "Categoría de documento actualizada exitosamente."
  },
  "Document category was added successfully.": {
    english: "Document category was added successfully.",
    spanish: "Categoría de documento agregada exitosamente."
  },
  "Document category retrieved successfully.": {
    english: "Document category retrieved successfully.",
    spanish: "Categoría de documento obtenida exitosamente."
  },
  "Document categories retrieved successfully": {
    english: "Document categories retrieved successfully",
    spanish: "Categorías de documentos obtenidas exitosamente"
  },
  "Sorry, we have no document categories for you.": {
    english: "Sorry, we have no document categories for you.",
    spanish: "Lo sentimos, no tenemos categorías de documentos para ti."
  },
  "You are authorized.": {
    english: "You are authorized.",
    spanish: "Estás autorizado."
  },
  "We uploaded your signed document successfully.": {
    english: "We uploaded your signed document successfully.",
    spanish: "Documento firmado cargado exitosamente."
  },
  "We uploaded the signature document successfully.": {
    english: "We uploaded the signature document successfully.",
    spanish: "Documento de firma cargado exitosamente."
  },
  "We uploaded the signature successfully.": {
    english: "We uploaded the signature successfully.",
    spanish: "Firma cargada exitosamente."
  },
  "Authorized": {
    english: "Authorized",
    spanish: "Autorizado"
  },
  "Document set to not active successfully.": {
    english: "Document set to not active successfully.",
    spanish: "Documento desactivado exitosamente."
  },
  "Document updated successfully": {
    english: "Document updated successfully",
    spanish: "Documento actualizado exitosamente"
  },
  "Photo updated successfully": {
    english: "Photo updated successfully",
    spanish: "Foto actualizada exitosamente"
  },
  "Photo saved successfully": {
    english: "Photo saved successfully",
    spanish: "Foto guardada exitosamente"
  },
  "Document saved successfully": {
    english: "Document saved successfully",
    spanish: "Documento guardado exitosamente"
  },
  "Retrieved document successfully.": {
    english: "Retrieved document successfully.",
    spanish: "Documento obtenido exitosamente."
  },
  "This patient has no documents.": {
    english: "This patient has no documents.",
    spanish: "Este paciente no tiene documentos."
  },
  "Retrieved documents successfully.": {
    english: "Retrieved documents successfully.",
    spanish: "Documentos obtenidos exitosamente."
  },
  "You have no documents.": {
    english: "You have no documents.",
    spanish: "No tienes documentos."
  },
  "Retrieved Signature Documents Successfully.": {
    english: "Retrieved Signature Documents Successfully.",
    spanish: "Documentos de firma obtenidos exitosamente."
  },
  "You have no documents to sign.": {
    english: "You have no documents to sign.",
    spanish: "No tienes documentos para firmar."
  },
  "You have not created any signature documents.": {
    english: "You have not created any signature documents.",
    spanish: "No has creado ningún documento de firma."
  },
  "User Is Authorized To Delete This Document": {
    english: "User Is Authorized To Delete This Document",
    spanish: "El usuario está autorizado para eliminar este documento"
  },
  "Product photo added successfully. ": {
    english: "Product photo added successfully. ",
    spanish: "Foto del producto agregada exitosamente. "
  },
  "No media of that type exist for this product.": {
    english: "No media of that type exist for this product.",
    spanish: "No existe ningún medio de ese tipo para este producto."
  },
  "No products exist.": {
    english: "No products exist.",
    spanish: "No existen productos."
  },
  "Here are the patients we found with your search.": {
    english: "Here are the patients we found with your search.",
    spanish: "Aquí están los pacientes que encontramos con tu búsqueda."
  },
  "Patient Set To Not Active Successfully.": {
    english: "Patient Set To Not Active Successfully.",
    spanish: "Paciente desactivado exitosamente."
  },
  "If you have an account with us, an email with instructions has been sent": {
    english: "If you have an account with us, an email with instructions has been sent",
    spanish: "Si tienes una cuenta con nosotros, se ha enviado un correo electrónico con instrucciones"
  },
  "Changed signature document status to private successfully.": {
    english: "Changed signature document status to private successfully.",
    spanish: "Estado del documento de firma cambiado a privado exitosamente."
  },
  "Changed signature document status to public successfully.": {
    english: "Changed signature document status to public successfully.",
    spanish: "Estado del documento de firma cambiado a público exitosamente."
  },
  "Deactivated signature document successfully.": {
    english: "Deactivated signature document successfully.",
    spanish: "Documento de firma desactivado exitosamente."
  },
  "Activated signature document successfully.": {
    english: "Activated signature document successfully.",
    spanish: "Documento de firma activado exitosamente."
  },
  "Documents resent out for signature.": {
    english: "Documents resent out for signature.",
    spanish: "Documentos reenviados para firma."
  },
  "Assigned signature documents successfully.  Sending out documents for signature.": {
    english: "Assigned signature documents successfully.  Sending out documents for signature.",
    spanish: "Documentos de firma asignados exitosamente. Enviando documentos para firma."
  },
  "Sorry, failed to assign Signature Document. ": {
    english: "Sorry, failed to assign Signature Document. ",
    spanish: "Lo sentimos, no se pudo asignar el documento de firma. "
  },
  "You have no orders.": {
    english: "You have no orders.",
    spanish: "No tienes pedidos."
  },
  "You have no tracking info.": {
    english: "You have no tracking info.",
    spanish: "No tienes información de seguimiento."
  },
  "Sorry, you have no Notifications.": {
    english: "Sorry, you have no Notifications.",
    spanish: "Lo sentimos, no tienes notificaciones."
  },
  "Not A Valid Token.": {
    english: "Not A Valid Token.",
    spanish: "Token no válido."
  },
  "Patient does not have date of birth in our records.": {
    english: "Patient does not have date of birth in our records.",
    spanish: "El paciente no tiene fecha de nacimiento en nuestros registros."
  },
  "Date of birth does not match.": {
    english: "Date of birth does not match.",
    spanish: "La fecha de nacimiento no coincide."
  },
  "Please check your email to finish verifying your account.": {
    english: "Please check your email to finish verifying your account.",
    spanish: "Por favor revisa tu correo electrónico para terminar de verificar tu cuenta."
  },
  "Password expired.": {
    english: "Password expired.",
    spanish: "Contraseña expirada."
  },
  "Account is not active": {
    english: "Account is not active",
    spanish: "La cuenta no está activa"
  },
  "The old password does not match the current password.": {
    english: "The old password does not match the current password.",
    spanish: "La contraseña anterior no coincide con la contraseña actual."
  },
  "The new password and the new password confirmation were not the same.": {
    english: "The new password and the new password confirmation were not the same.",
    spanish: "La nueva contraseña y la confirmación de la nueva contraseña no fueron iguales."
  },
  "The new password has already been used": {
    english: "The new password has already been used",
    spanish: "La nueva contraseña ya ha sido utilizada"
  },
  "Incorrect code, please try again": {
    english: "Incorrect code, please try again",
    spanish: "Código incorrecto, por favor intenta de nuevo"
  },
  "The code has expired": {
    english: "The code has expired",
    spanish: "El código ha expirado"
  },
  "No valid code found": {
    english: "No valid code found",
    spanish: "No se encontró un código válido"
  },
  "No Patients Found.": {
    english: "No Patients Found.",
    spanish: "No se encontraron pacientes."
  },
  "This email address cannot be used, your email address was not a valid pattern.": {
    english: "This email address cannot be used, your email address was not a valid pattern.",
    spanish: "Esta dirección de correo electrónico no se puede usar, tu dirección de correo electrónico no era un patrón válido."
  },
  "This email address cannot be used, please try another email address.": {
    english: "This email address cannot be used, please try another email address.",
    spanish: "Esta dirección de correo electrónico no se puede usar, por favor intenta con otra dirección de correo electrónico."
  },
  "could not find Change of Address Task": {
    english: "could not find Change of Address Task",
    spanish: "no se pudo encontrar la tarea de cambio de dirección"
  },
  "could not find Change of Insurance Task": {
    english: "could not find Change of Insurance Task",
    spanish: "no se pudo encontrar la tarea de cambio de seguro"
  },
  "Could not find Name Change Task": {
    english: "Could not find Name Change Task",
    spanish: "No se pudo encontrar la tarea de cambio de nombre"
  },
  "Could not find Physician Change Task": {
    english: "Could not find Physician Change Task",
    spanish: "No se pudo encontrar la tarea de cambio de médico"
  },
  "Could not find Change of Phone number Task": {
    english: "Could not find Change of Phone number Task",
    spanish: "No se pudo encontrar la tarea de cambio de número de teléfono"
  },
  "Failed to cancel appointment": {
    english: "Failed to cancel appointment",
    spanish: "Error al cancelar la cita"
  },
  "Therapy Data created successfuly.": {
    english: "Therapy Data created successfuly.",
    spanish: "Datos de terapia creados exitosamente."
  },
  "Therapy Data record updated successfully.": {
    english: "Therapy Data record updated successfully.",
    spanish: "Registro de datos de terapia actualizado exitosamente."
  },
  "Therapy Data deleted updated successfuly": {
    english: "Therapy Data deleted updated successfuly",
    spanish: "Datos de terapia eliminados exitosamente"
  },
  "Appointment added successfully.": {
    english: "Appointment added successfully.",
    spanish: "Cita agregada exitosamente."
  },
  "Appointment/s created successfully": {
    english: "Appointment/s created successfully",
    spanish: "Cita(s) creada(s) exitosamente"
  },
  "Appointment created and accepted successfully": {
    english: "Appointment created and accepted successfully",
    spanish: "Cita creada y aceptada exitosamente"
  },
  "Time Off Added successfully.": {
    english: "Time Off Added successfully.",
    spanish: "Tiempo libre agregado exitosamente."
  },
  "Time Off Updated successfully.": {
    english: "Time Off Updated successfully.",
    spanish: "Tiempo libre actualizado exitosamente."
  },
  "Time Off Deleted successfully.": {
    english: "Time Off Deleted successfully.",
    spanish: "Tiempo libre eliminado exitosamente."
  },
  "Please, before inactivating the patient, complete the Compliance Data Tab": {
    english: "Please, before inactivating the patient, complete the Compliance Data Tab",
    spanish: "Por favor, antes de desactivar al paciente, completa la pestaña de Datos de Cumplimiento"
  }
};

